// src/componentes/tienda/tiendaPublica/LogosPago.js
// Logos de los medios de pago (pie, carrito y pago del pedido), en fichas
// blancas como las marcas de aceptación del retail. Los archivos están en
// public/pagos: se sirven del hosting, fuera del paquete de la tienda.
import React from 'react';
import { Landmark } from 'lucide-react';

const LOGOS = {
  visa: { src: '/pagos/visa.webp', nombre: 'Visa', ancho: 200, alto: 66 },
  mastercard: { src: '/pagos/mastercard.svg', nombre: 'Mastercard', ancho: 48, alto: 30 },
  yape: { src: '/pagos/yape.webp', nombre: 'Yape', ancho: 128, alto: 128 },
  plin: { src: '/pagos/plin.webp', nombre: 'Plin', ancho: 128, alto: 128 },
};

export const LogoPago = ({ medio }) => {
  const logo = LOGOS[medio];
  if (logo) {
    return <span className={`tp-logo-pago tp-logo-pago--${medio}`}>
      <img src={logo.src} alt={logo.nombre} width={logo.ancho} height={logo.alto} loading="lazy" decoding="async" />
    </span>;
  }
  if (medio === 'transferencia') return <span className="tp-logo-pago tp-logo-pago--texto"><Landmark size={14} aria-hidden="true" />Transferencia</span>;
  return null;
};

export const LogosPago = ({ medios, etiqueta = 'Medios de pago aceptados', className = '' }) => (medios?.length
  ? <ul className={`tp-logos-pago ${className}`.trim()} aria-label={etiqueta}>
    {medios.map((medio) => <li key={medio}><LogoPago medio={medio} /></li>)}
  </ul>
  : null);
